module.exports = __webpack_public_path__ + "static/media/file-thumbnail.4500f926.png";